export class IntNumber {
  private value?: number;
  private constructor(value?: number) {
    this.value = value;
  }

  static fromNumber(value?: number) {
    return new IntNumber(value);
  }

  addTo(other: IntNumber) {
    if (this.value === undefined || other.value === undefined) return undefined;

    return this.value + other.value;
  }

  toNumber() {
    return this.value;
  }

  toFixedNumber() {
    return this.value?.toFixed(0);
  }
}
